module.exports = __webpack_public_path__ + "img/5.1f81a220.jpg";